<template>
	<div :class="prefixCls + '-head'"
		:style="{
			width: headerWidth
		}">
		<table cellspacing="0" cellpadding="0" border="0" 
			:style="styles">
	        <colgroup>
	            <col v-for="(col, i) in endColumns" :key="i"  :width="col.width">
	            <col v-if="showVerticalScrollBar" :width="$parent.scrollBarWidth"/>
	        </colgroup>
	        <thead>
	        	<tr v-for="(floor, i) in stackColumns" :key="i">
	        		<th v-for="(col, j) in floor" :key="j"
	        			:class="[
	        				prefixCls + '-th',
	        				{
	        					'with-border': stackColumns.length > 1
	        				}
        				]"
	        			:style="{
	        				height: col._rowspan * 40 + 'px',
							'visibility': col.fixed == location ? 'visible' : 'hidden'
						}"
						:align="col.align || 'center'"
						:rowspan="col._rowspan"
						:colspan="col._colspan">
	        			{{col.title}}
	        		</th>
	        	</tr>
	    	</thead>
	    </table>
	</div>
</template>
<script>
	export default {
		name: "TreeTableHead",

		props: {
			width: {
				type: Number,
				default: 0
			},
			location: {
				type: String,
				default: "middle",
				validator: val => ["left", "middle", "right"].indexOf(val) >= 0
			},
			columns: {
				type: Array,
				default: function() {
					return []
				}
			},
			showVerticalScrollBar: {
				type: Boolean,
				default: false
			},
		},
		
		computed:{
			prefixCls(){
                return "ivu-tree-table"
            },
            endColumns(){
            	return this.columns.filter(c => c._isEnd)
            },
            cloumnWidth(){
            	return this.endColumns.reduce((w, col) => w + col.width, 0) + 'px'
            },
            headerWidth(){
            	return this.width ? this.width + 'px' : this.cloumnWidth
            },
            styles(){
            	return {
            		width: this.cloumnWidth,
            		tableLayout: "fixed"
            	}
            },
            stackColumns(){
            	var stacks = []

            	this.columns.forEach(col => {
            		if(stacks[col._level]){
            			stacks[col._level].push(col)
            		}else{
            			stacks[col._level] = [col]
            		}
            	})

            	return stacks
            }
		}
	}
</script>
